import {EntityType} from "../core/entityType";
import {Operation} from "../core/operation";

export const entityType = EntityType.MyProfile;
export const entityOperations = [
  Operation.getAll,
  Operation.update,
];
